import {Breadcrumb} from 'src/feature/bite/component'
import {useGetDetail} from '../context/useQuery'

import {useIntl} from 'react-intl'
import Detail from '../component/Detail'
import {BreadCrumb} from 'src/_metronic/layout/components'
import {useNavigate} from 'react-router-dom'

export default function TerminalDetail() {
  const intl = useIntl()

  const {isLoading} = useGetDetail()
  const navigate = useNavigate()

  return (
    <>
      <div className='d-flex gap-5 align-items-center mb-10'>
        <button
          className='btn btn-primary btn-sm btn-back'
          onClick={() => {
            navigate('/stores')
          }}
        >
          <i className='fa fa-arrow-left'></i>
        </button>
        <BreadCrumb currentPage={'TPN Details'} />
      </div>
      <Detail isLoading={isLoading} />
    </>
  )
}
